module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Align-auto-e6cce5dd227786f4efdf2a87dc48dc8d.svg";